import type { Uuid } from '@common/utils/uuid';
import { type FundingErrorCode, FundingResultType, type NotFundedReason } from '@common/enums';

export interface FundingResult {
    episodeCategoryId: Uuid;
    errorCode: FundingErrorCode | null;
    fundingErrorInformation: string | null;
    id: string;
    notFundedReason: NotFundedReason | null;
    patientId: Uuid;
    processNumber: number;
    recordedDatetime: Date | string;
    type: FundingResultType;
}

export interface FundingError extends FundingResult {
    errorCode: FundingErrorCode;
    type: FundingResultType.error;
}

export interface NotFunded extends FundingResult {
    notFundedReason: NotFundedReason;
    type: FundingResultType.notFunded;
}

export function isFundingError(fundingResult: FundingResult | undefined): fundingResult is FundingError {
    return fundingResult?.type === FundingResultType.error;
}

export function isNotFunded(fundingResult: FundingResult | undefined): fundingResult is NotFunded {
    return fundingResult?.type === FundingResultType.notFunded;
}
